import styled from 'styled-components';
import { Stack } from '@workramp/ui';

export const ModuleContainer = styled(Stack)`
  margin-bottom: ${({ theme }) => theme.spacing(4)}px;
  padding-left: ${({ theme }) => theme.spacing(2)}px;
`;

export const List = styled.ul`
  margin: ${({ theme }) => theme.spacing(1)}px 0 ${({ theme }) => theme.spacing(2)}px 0;
  padding-left: ${({ theme }) => theme.spacing(2)}px;
`;

export const ListItem = styled.li`
  font-size: 13px;
  margin-bottom: ${({ theme }) => theme.spacing(1)}px;
  color: var(--color-text-primary);
`;
